export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-200">
      <div className="wrap py-12 md:py-14">
        <div className="grid gap-8 md:grid-cols-[1.2fr_1fr]">
          <div>
            <a href="#top" className="flex items-center gap-3">
              <span className="inline-flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-poster text-lg text-background-50">
                91
              </span>
              <span className="eyebrow text-lg font-black text-foreground-950">
                吃瓜<span className="text-primary-600">91</span>
              </span>
            </a>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一份中文网络数字梗释义小站：把「吃瓜91什么意思、怎么解读、由来与说法」整理成好读的词条。
              内容基于民间流传说法梳理，仅供轻松阅读与聊天参考，不构成任何官方定义。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-6">
            <nav aria-label="词条导航">
              <h4 className="mb-3 text-xs font-semibold tracking-widest text-foreground-500">词条目录</h4>
              <ul className="space-y-2 text-sm">
                {[
                  ["#meaning", "什么意思"],
                  ["#decode", "数字解读"],
                  ["#compare", "说法对比"],
                  ["#origin", "由来说法"],
                ].map(([h, label]) => (
                  <li key={h}>
                    <a href={h} className="whitespace-nowrap text-foreground-700 hover:text-primary-600">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
            <nav aria-label="更多">
              <h4 className="mb-3 text-xs font-semibold tracking-widest text-foreground-500">延伸阅读</h4>
              <ul className="space-y-2 text-sm">
                {[
                  ["#use", "怎么接不冷场"],
                  ["#copy", "一句话释义"],
                  ["#faq", "常见问答"],
                  ["#top", "回到顶部"],
                ].map(([h, label]) => (
                  <li key={h}>
                    <a href={h} className="whitespace-nowrap text-foreground-700 hover:text-primary-600">
                      {label}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 吃瓜91 · 数字梗小词典 · 仅供娱乐</p>
          <p className="flex items-center gap-2">
            <i className="ri-leaf-line h-4 w-4 flex items-center justify-center text-accent-600" />
            吃瓜91含义、密码解读、由来说法均为民间整理
          </p>
        </div>
      </div>
    </footer>
  );
}